const MINUTES_IN_DAY = 24 * 60;
const STEP_MINUTES = 5;

function minutesOf(time: string): number {
  const parts = time.split(":");
  const hours = Number(parts[0] ?? 0);
  const minutes = Number(parts[1] ?? 0);
  return hours * 60 + minutes;
}

function timeOf(minutes: number): string {
  const clamped = Math.min(MINUTES_IN_DAY - STEP_MINUTES, Math.max(0, minutes));
  const hours = Math.floor(clamped / 60);
  const mins = clamped % 60;
  return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
}

interface Props {
  value: string;
  onChange: (value: string) => void;
  accentClassName?: string;
}

export default function TimeSlider({ value, onChange, accentClassName }: Props) {
  return (
    <input
      type="range"
      min={0}
      max={MINUTES_IN_DAY - STEP_MINUTES}
      step={STEP_MINUTES}
      value={minutesOf(value)}
      onChange={(event) => {
        onChange(timeOf(Number(event.target.value)));
      }}
      aria-label="時刻をスライドして調整"
      className={`h-1.5 w-full touch-none appearance-none rounded-full bg-[var(--color-line)] ${accentClassName ?? "accent-[var(--color-teal)]"}`}
    />
  );
}
